import client from '../client';

export const userApis = {
  getUsers: (data: { companyId: number; category: string; keyword: string; service: string }) =>
    client.get('/user', { params: data }),
};
